// Axios
/* eslint-disable no-param-reassign */
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { showToast } from '@/libs/toastification'
// eslint-disable-next-line
import useJwt from '@/auth/jwt/useJwt'
// eslint-disable-next-line
import { getEnvVariable } from '@/helpers'

const Identity = axios.create({
  baseURL: getEnvVariable('VUE_APP_IDENTITY_URL', process.env.VUE_APP_IDENTITY_URL),
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/x-www-form-urlencoded',
    'X-Tenant-Id': getEnvVariable(
      'VUE_APP_DEFAULT_TENANT',
      process.env.VUE_APP_DEFAULT_TENANT
    ),
  },
  timeout: getEnvVariable('TIME_ABORT_REQUEST', process.env.TIME_ABORT_REQUEST),
})

Identity.interceptors.request.use(config => {
  const token = useJwt.getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// toast notifications when error 🧨💣
Identity.interceptors.response.use(
  response => response,
  error => {
    if (error.response.data.message) {
      showToast({
        component: ToastificationContent,
        props: {
          title: 'Error',
          icon: 'AlertCircleIcon',
          variant: 'danger',
          text: error.response.data.message,
        },
      })
    }
    if (error.response.data.messages) {
      error.response.data.messages.forEach(err => {
        showToast({
          component: ToastificationContent,
          props: {
            title: 'Error',
            icon: 'AlertCircleIcon',
            variant: 'danger',
            text: err,
          },
        })
      })
    }
    return Promise.reject(error)
  },
)

export default Identity
/* eslint-enable no-param-reassign */
